import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { cityActions, userActions, userSelectors } from "../../redux";
import { onAutentication } from "../../services/firebase/authentication";
import { asyncMapUserFromFirebase } from "../../utils";
import AppDrawer from "../AppDrawer";
import AppRoutes from "../AppRouter";
import GlobalLoader from "../GlobalLoader";
import ThemeProvider from "../ThemeProvider";
import "./App.css";

const App: React.FC<{}> = () => {
  const currentRole = useSelector(userSelectors.getCurrentRole);
  const dispatch = useDispatch();

  useEffect(() => {
    onAutentication(async (firebaseUser) => {
      if (firebaseUser) {
        const user = await asyncMapUserFromFirebase(firebaseUser);
        dispatch(userActions.setUser(user));
        dispatch(cityActions.loadAllCity({}));
      }
    });
  }, [dispatch]);

  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <GlobalLoader></GlobalLoader>
            <AppDrawer role={currentRole} title="Abruzzo in spiaggia">
              <AppRoutes role={currentRole} />
            </AppDrawer>
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
